<template>
  <v-row no-gutters>
    <v-col cols="12">
      <div v-for="(charity, index) in charities" :key="index">
        <div class="list-item">
          <v-btn
            class="list-item-btn"
            :ripple="false"
            block
            color="white"
            @click.stop="(showDialog = true), (charityToUpdate = charity)"
          >
            <div class="list-item-text">
              <span class="list-item-name">{{ charity.name }}</span>
              <span
                v-if="charity.registrationNumber"
                class="list-item-separator"
                >-</span
              >
              <span class="list-item-more-info">{{
                charity.registrationNumber
              }}</span>
              <BeneficiaryDonationDetails :beneficiary="charity" />
            </div>
          </v-btn>
        </div>
      </div>
      <div class="mt-5 mb-5">
        <AlternativeButton
          :title="'Add Charity'"
          @gradientButtonClicked="addCharityClicked"
        />
      </div>
    </v-col>
    <CharityDialog v-model="showDialog" :charity-to-update="charityToUpdate" />
  </v-row>
</template>

<script>
  import CharityDialog from './CharityDialog.vue';
  import BeneficiaryDonationDetails from './BeneficiaryDonationDetails';

  export default {
    name: 'CharitiesList',
    components: {
      CharityDialog,
      BeneficiaryDonationDetails,
    },
    props: {
      charities: {
        required: true,
        type: Array,
      },
    },
    data() {
      return {
        showDialog: false,
        charityToUpdate: {},
      };
    },
    methods: {
      addCharityClicked() {
        this.charityToUpdate = {};
        this.showDialog = true;
        this.sendGADataLayer('your-people-add-new-charity');
      },
      sendGADataLayer(event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: event,
          omuserid: this.$store.getters?.userId,
        });
      },
    },
  };
</script>
